import axios from "../axios-auth";

export const shopService = {
  getAllShops
};

function getAllShops() {
  return axios.get("auth/shops");
}
